import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "mobile"]

  toggle() {
    if (this.hasMobileTarget) {
      this.mobileTarget.classList.toggle("hidden")
    }
  }

  close() {
    if (this.hasMobileTarget) {
      this.mobileTarget.classList.add("hidden")
    }
  }

  scroll(event) {
    const href = event.currentTarget.getAttribute("href")
    if (!href || !href.startsWith("#")) return

    const target = document.querySelector(href)
    if (!target) return

    event.preventDefault()
    target.scrollIntoView({ behavior: "smooth", block: "start" })
    this.close()
  }
}
